import { render, staticRenderFns } from "./SvgIcons.vue?vue&type=template&id=2db49bea"
import script from "./SvgIcons.vue?vue&type=script&lang=js"
export * from "./SvgIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports